import { inject as d, resolveComponent as i, openBlock as s, createBlock as r, resolveDynamicComponent as l, mergeProps as m, createSlots as u, withCtx as o, renderSlot as t, createCommentVNode as f } from "vue";
import g from "./design-system.es38.js";
import p from "./design-system.es59.js";
import B from "./design-system.es58.js";
/* empty css                    */
/* empty css                    */
import k from "./design-system.es128.js";
const _ = {
  name: "DsToggleButton",
  components: {
    DsButton: g,
    IconButton: p,
    Icon: B
  },
  props: {
    /**
     * Determines whether the button is checked or not.
     */
    checked: Boolean,
    /**
     * The icon to display in the button. This should be used for the icon variant and should not be used with the leading or
     * trailing slots. The boolean value should be used when used when passing an icon to the default slot.
     */
    icon: [String, Boolean]
  },
  setup() {
    const { dense: e } = d("dsToggle", { dense: !1 });
    return {
      dense: e
    };
  }
};
function I(e, h, n, a, $, v) {
  const c = i("Icon");
  return s(), r(l(n.icon ? "IconButton" : "DsButton"), m({
    variant: "custom",
    dense: a.dense
  }, e.$attrs, {
    class: ["ds-toggle-button", {
      "ds-toggle-button--checked": n.checked
    }]
  }), u({
    default: o(() => [
      t(e.$slots, "default", {}, () => [
        n.icon ? (s(), r(c, {
          key: 0,
          name: n.icon
        }, null, 8, ["name"])) : f("", !0)
      ], !0)
    ]),
    _: 2
  }, [
    e.$slots.leading ? {
      name: "leading",
      fn: o(() => [
        t(e.$slots, "leading", {}, void 0, !0)
      ]),
      key: "0"
    } : void 0,
    e.$slots.trailing ? {
      name: "trailing",
      fn: o(() => [
        t(e.$slots, "trailing", {}, void 0, !0)
      ]),
      key: "1"
    } : void 0
  ]), 1040, ["dense", "class"]);
}
const w = /* @__PURE__ */ k(_, [["render", I], ["__scopeId", "data-v-f8c7a857"]]);
export {
  w as default
};
//# sourceMappingURL=design-system.es111.js.map
